import { ReactElement } from 'react';

import { TherapeuticGroupType } from '@dreryk/egabinet-group-session-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Multiselect } from '@dreryk/react-components';

import {
   GroupSessionsFilterPanelFormBean,
   GroupSessionsFilterPanelSearchParam,
   GroupSessionsFilterPanelStorageKey,
} from '../../GroupSessionsFilterPanel.types';
import { translationKeys } from '../../../translations';

import {
   createGroupTypeTriggerLabelExtractor,
   GROUP_TYPES,
   groupTypesCodec,
   groupTypesDeselectorsPropsMapper,
} from './GroupTypeController.utils';
import { StyledGroupTypeMultiselect } from './GroupTypeMultiselect.styled';

type GroupTypeControllerProps = {
   registerController: BindingCreator<GroupSessionsFilterPanelFormBean, 'groupTypes'>;
};

export const GroupTypeController = (props: GroupTypeControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<GroupSessionsFilterPanelFormBean, 'groupTypes'>
         name={'groupTypes'}
         searchParam={GroupSessionsFilterPanelSearchParam.GROUP_TYPE}
         storageKey={GroupSessionsFilterPanelStorageKey.GROUP_TYPE}
         codec={groupTypesCodec}
         chipsLabel={translationKeys.groupType}
         getDeselectorsProps={groupTypesDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledGroupTypeMultiselect<TherapeuticGroupType>
               testId={'groupTypes'}
               triggerLabelExtractor={createGroupTypeTriggerLabelExtractor(translate)}
               controller={props.registerController('groupTypes')}
               onHide={applyFilter}
               label={translationKeys.groupType}
               placeholder={translationKeys.chooseGroupType}
               compact
               disabled
            >
               <>
                  <Multiselect.SelectAll testId={'selectAllGroupTypes'} items={GROUP_TYPES} />
                  <Multiselect.List<TherapeuticGroupType> items={GROUP_TYPES}>
                     {(item) => (
                        <Multiselect.Item
                           item={item}
                           label={translationKeys.groupSessionsTypeMap[item]}
                           testId={item}
                        />
                     )}
                  </Multiselect.List>
               </>
            </StyledGroupTypeMultiselect>
         )}
      </FilterPanel.Controller>
   );
};
